import { Module } from "vuex";

import { PractitionersAPI } from "@/api/practitioners";
import { RootState } from "@/types";
import { Practitioner } from "@/types/users";

interface PractitionersState {
  practitioners: Practitioner[];
}

export const practitioners: Module<PractitionersState, RootState> = {
  namespaced: true,
  state: {
    practitioners: [],
  },
  mutations: {
    setPractitioners(state, payload) {
      state.practitioners = payload;
    },
  },
  actions: {
    async getAllPractitioners({ commit }) {
      const practitioners = await PractitionersAPI.getAllPractitioners();
      commit("setPractitioners", practitioners);
    },
  },
  getters: {
    practitioners(state) {
      return state.practitioners;
    },
  },
};
